export const INCIDENT_TYPES = [
  'Active Threat',
  'Aggressive Customer',
  'Critical Incident',
  'Cyber Incident',
  'Cyclone / Severe Weather',
  'Earthquake',
  'Exercise',
  'Extortion',
  'Fire',
  'Flood',
  'Kidnap for Ransom (KRE)',
  'Medical Emergency',
  'Meeting/Event Incident',
  'Protest / Civil Unrest',
  'Reputational Incident',
  'Suspicious Item / Bomb Threat',
  'Threats Against Executive',
  'Other'
]; 